import { render, staticRenderFns } from "./ImportAddMatrixModal.vue?vue&type=template&id=a62fbc52&"
import script from "./ImportAddMatrixModal.vue?vue&type=script&lang=js&"
export * from "./ImportAddMatrixModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports